import FacebookOutlinedIcon from '@portalterreno/react-ui-icons/FacebookOutlinedIcon';
import { useTranslation } from 'next-i18next';
import React from 'react';

import useWindowOpen from '../../../../../../hooks/useWindowOpen';
import StyledListItem from '../StyledListItem';
import withShareUrl, { WithShareUrlProps } from './withShareUrl';

export type FacebookButtonShareProps = Omit<WithShareUrlProps, 'children'>;

const FacebookButtonShare: React.FC<FacebookButtonShareProps> = ({
  shareUrl,
  ...rest
}) => {
  const url = React.useMemo(() => {
    return `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
  }, [shareUrl]);

  const handleButtonClick = useWindowOpen(url);
  const { t } = useTranslation('social');
  return (
    <StyledListItem
      leftIcon={<FacebookOutlinedIcon />}
      onClick={handleButtonClick}
      {...rest}
    >
      {t('facebookButtonShare')}
    </StyledListItem>
  );
};

export default withShareUrl(FacebookButtonShare, 'facebook');
